var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "row row-wrap"
  }, [_c('a', {
    staticClass: "col-xs-12 aItem row sideless",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "id": _vm.item.sid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.item_clicked()
      }
    }
  }, [_c('div', {
    staticClass: "icon-text-container",
    class: {
      'active-tree-item': (_vm.item.sid == _vm.$root.active_tree_item.id && (_vm.$route.query.p == _vm.item.idp || _vm.$route.query.p == null))
    }
  }, [_c('span', {
    staticStyle: {
      "padding": "0px"
    }
  }, [(!_vm.isFirstSon) ? _c('div', {
    staticClass: "sideless side-branch",
    class: {
      'last': _vm.ind == _vm.$parent.children.length - 1
    }
  }, [_c('div', {
    staticClass: "branch top"
  }), _vm._v(" "), _c('div', {
    staticClass: "branch bot"
  })]) : _vm._e(), _vm._v(" "), (!_vm.configs.showValidity || true) ? _c('i', {
    class: _vm.$root.prod_icons[_vm.item.typ] ? _vm.$root.prod_icons[_vm.item.typ].icn : _vm.$root.icons.dir
  }) : _c('i', {
    class: _vm.$root.prod_icons[_vm.item.typ] ? _vm.$root.prod_icons[_vm.item.typ].icn : _vm.$root.icons.dir,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggle()
      }
    }
  }, [(_vm.configs.showValidity) ? _c('span', {
    staticClass: "icon-toggle-validity"
  }, [(!_vm.showDetail) ? _c('strong', [_vm._v("+")]) : _c('strong', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("x")])]) : _vm._e()])]), _vm._v(" "), (_vm.item.gco && !_vm.loading) ? _c('span', {
    staticStyle: {
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.arrow_clicked()
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.children.length == 0 ? _vm.$root.icons.right : _vm.$root.icons.down]
  })]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "custom_spinner",
    staticStyle: {
      "margin": "0px -3px 0px 3px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hide-collapse"
  }, [(_vm.configs.showId) ? _c('span', [_vm._v(_vm._s(_vm.item.sid + " - "))]) : _vm._e(), _vm._v(_vm._s(_vm.item.des))])])])]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu",
    class: {
      'first': _vm.isFirstSon, 'child': !_vm.isFirstSon, 'fatherlast': _vm.isFirstSon || _vm.ind == _vm.$parent.children.length - 1
    },
    attrs: {
      "id": _vm.heir
    }
  }, [_vm._l((_vm.children), function(child, index) {
    return (_vm.item.opened) ? _c('li', {
      key: child.sid,
      staticClass: "pageLink"
    }, [(child.triggered) ? _c('recursive-item', {
      attrs: {
        "item": child,
        "ind": index,
        "configs": _vm.configs,
        "executeOnOpen": child.execonopen,
        "navigationPendingPromise": child.nav_promise
      },
      on: {
        "shrimp_build_path": _vm.ShrimpBuildPath
      }
    }) : _c('div', {
      staticClass: "row row-wrap"
    }, [_c('a', {
      staticClass: "col-xs-12 aItem row sideless",
      staticStyle: {
        "margin": "0px"
      },
      attrs: {
        "id": child.sid
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleOnSon('item_clicked', index)
        }
      }
    }, [_c('div', {
      staticClass: "icon-text-container"
    }, [_c('span', {
      staticStyle: {
        "padding": "0px"
      }
    }, [(_vm.children != null) ? _c('div', {
      staticClass: "sideless side-branch",
      class: {
        'last': index == _vm.children.length - 1
      }
    }, [_c('div', {
      staticClass: "branch top"
    }), _vm._v(" "), _c('div', {
      staticClass: "branch bot"
    })]) : _vm._e(), _vm._v(" "), (!_vm.configs.showValidity || true) ? _c('i', {
      class: _vm.$root.prod_icons[child.typ] ? _vm.$root.prod_icons[child.typ].icn : _vm.$root.icons.dir
    }) : _c('i', {
      class: _vm.$root.prod_icons[child.typ] ? _vm.$root.prod_icons[child.typ].icn : _vm.$root.icons.dir,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleOnSon('toggle', index)
        }
      }
    }, [(_vm.configs.showValidity) ? _c('span', {
      staticClass: "icon-toggle-validity"
    }, [_c('strong', [_vm._v("+")])]) : _vm._e()])]), _vm._v(" "), (child.gco) ? _c('span', {
      staticStyle: {
        "padding": "5px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleOnSon('arrow_clicked', index)
        }
      }
    }, [_c('i', {
      class: _vm.$root.icons.right
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "hide-collapse"
    }, [(_vm.configs.showId) ? _c('span', [_vm._v(_vm._s(child.sid + " - "))]) : _vm._e(), _vm._v(_vm._s(child.des))])])])])], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.leaves), function(leaf, i) {
    return _c('li', {
      key: leaf.sid,
      staticClass: "pageLink"
    }, [_c('recursiveListDocument', {
      attrs: {
        "item": leaf,
        "ind": i,
        "configs": _vm.configs
      },
      on: {
        "shrimp_build_path": _vm.ShrimpBuildPath
      }
    })], 1)
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5747b4e5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree/recursive-list-item.vue
// module id = 1362
// module chunks = 1